// Offset pagination — page-number UX with first/last jumps.
import type { PageSize } from "../../types/inpact";

interface PaginationFooterProps {
  page: number;
  pageSize: PageSize;
  total: number;
  totalPages: number;
  onPageChange: (p: number) => void;
  onPageSizeChange: (s: PageSize) => void;
}

export function PaginationFooter({
  page,
  pageSize,
  total,
  totalPages,
  onPageChange,
  onPageSizeChange,
}: PaginationFooterProps) {
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  const last = Math.max(1, totalPages);
  return (
    <div className="pager">
      <span className="pager__range">
        Showing {start}–{end} of {total}
      </span>
      <div className="pager__right">
        <span className="pager__size">
          Rows per page:
          <select
            aria-label="Rows per page"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value) as PageSize)}
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </span>
        <nav className="pager__nav" aria-label="Results pagination">
          <button
            type="button"
            disabled={page <= 1}
            onClick={() => onPageChange(1)}
            aria-label="First page"
          >
            «
          </button>
          <button
            type="button"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Previous page"
          >
            ‹
          </button>
          <button type="button" aria-current="page" aria-label={`Page ${page} of ${last}`}>
            {page} / {last}
          </button>
          <button
            type="button"
            disabled={page >= last}
            onClick={() => onPageChange(page + 1)}
            aria-label="Next page"
          >
            ›
          </button>
          <button
            type="button"
            disabled={page >= last}
            onClick={() => onPageChange(last)}
            aria-label="Last page"
          >
            »
          </button>
        </nav>
      </div>
    </div>
  );
}
